module.exports = __webpack_public_path__ + "static/media/p32.bec40d3d.jpg";